import generateContext, { createAction } from '..';

interface IMobileViewState {
  showOrderDetailMobileView: boolean
  showHeaderPageReferenceText: boolean
}

const initialState: IMobileViewState = {
  showOrderDetailMobileView: false,
  showHeaderPageReferenceText: false
};

enum MobileViewActionType {
  SetOrderDetailMobileView = 'SET_ORDER_DETAIL_MOBILE_VIEW',
  SetShowHeaderPageReference = 'SET_SHOW_HEADER_PAGE_REFERENCE'
}

const reducer = (
  state: IMobileViewState,
  action: { type: MobileViewActionType; payload?: any }
): IMobileViewState => {
  switch (action.type) {
    case MobileViewActionType.SetOrderDetailMobileView:
        state.showOrderDetailMobileView = action.payload;
      return {
        ...state,
        
      };

    case MobileViewActionType.SetShowHeaderPageReference:
      state.showHeaderPageReferenceText = action.payload
      return {
        ...state
      }

    default:
      return state;
  }
};

const [MobileViewCtxProvider, useMobileViewState, useMobileViewDispatch] =
  generateContext(reducer, initialState);

const useMobileViewActions = () => {
  const dispatch = useMobileViewDispatch();


  const setOrderDetailMobileView = (showOrderDetailsMobile: boolean) => {
    dispatch(createAction(MobileViewActionType.SetOrderDetailMobileView,showOrderDetailsMobile));
  };

  const setMobileHeaderNavigationVisibility = (showHeaderPageReferanceText:boolean) => {
    dispatch(createAction(MobileViewActionType.SetShowHeaderPageReference,showHeaderPageReferanceText))
  }

  return {
    setOrderDetailMobileView,
    setMobileHeaderNavigationVisibility
  };
};

export { MobileViewCtxProvider, useMobileViewState, useMobileViewActions };
